if (!customElements.get('banner-audio-toggle')) {
  class BannerAudioToggle extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.media = Array.from(this.parentElement.querySelectorAll('video, iframe.js-youtube, iframe.js-vimeo'));
      this.onClick = () => {
        const video = this.visibleMedia();
        if (!video) return;
        const muted = this.button.getAttribute('aria-pressed') === 'true';
        this.setMuted(video, muted);
        this.button.setAttribute('aria-pressed', String(!muted));
      };
      this.onResize = () => {
        this.mute();
        this.updatePosition();
      };
      this.onVolumeChange = () => {
        const video = this.visibleMedia();
        if (video && video.tagName === 'VIDEO') {
          this.button.setAttribute('aria-pressed', String(!video.muted && video.volume > 0));
        }
      };
      this.button.addEventListener('click', this.onClick);
      window.addEventListener('resize', this.onResize);
      this.media.forEach(video => video.addEventListener('volumechange', this.onVolumeChange));
      this.resizeObserver = new ResizeObserver(() => this.updatePosition());
      this.resizeObserver.observe(this.parentElement);
      this.media.forEach(video => this.resizeObserver.observe(video.closest('.media')));
      this.updatePosition();
    }

    disconnectedCallback() {
      this.button.removeEventListener('click', this.onClick);
      window.removeEventListener('resize', this.onResize);
      this.resizeObserver.disconnect();
      this.media.forEach(video => video.removeEventListener('volumechange', this.onVolumeChange));
    }

    visibleMedia() {
      return this.media.find(video => video.getClientRects().length > 0);
    }

    updatePosition() {
      const video = this.visibleMedia();
      this.hidden = !video;
      if (!video) return;

      // Use the media container: background videos can extend beyond its crop.
      const mediaBounds = video.closest('.media').getBoundingClientRect();
      const parentBounds = this.offsetParent.getBoundingClientRect();
      const rtl = getComputedStyle(this).direction === 'rtl';
      const inlineOffset = rtl
        ? mediaBounds.left - parentBounds.left
        : parentBounds.right - mediaBounds.right;

      this.style.setProperty('--banner-audio-inline-offset', `${inlineOffset}px`);
      this.style.setProperty('--banner-audio-bottom-offset', `${parentBounds.bottom - mediaBounds.bottom}px`);
      this.style.setProperty('--banner-audio-top-offset', `${mediaBounds.top - parentBounds.top}px`);
      this.style.setProperty('--banner-audio-left-offset', `${mediaBounds.left - parentBounds.left}px`);
    }

    mute() {
      this.media.forEach(video => this.setMuted(video, true));
      this.button.setAttribute('aria-pressed', 'false');
    }

    setMuted(video, muted) {
      if (video.tagName === 'VIDEO') {
        video.muted = muted;
        if (!muted && video.volume === 0) video.volume = 1;
        return;
      }

      const origin = new URL(video.src).origin;
      if (video.classList.contains('js-youtube')) {
        video.contentWindow.postMessage(JSON.stringify({
          event: 'command', func: muted ? 'mute' : 'unMute', args: []
        }), origin);
      } else {
        video.contentWindow.postMessage(JSON.stringify({ method: 'setMuted', value: muted }), origin);
      }
    }
  }

  customElements.define('banner-audio-toggle', BannerAudioToggle);
}
